import { compile } from 'path-to-regexp'

export const Paths = {
  auth0login: '/connect',
  auth0Callback: '/auth0/callback',
  cognitoLogin: '/auth/cognito/login',
  cognitoCallback: '/auth/cognito/callback',
  cognitoLogout: '/auth/cognito/logout',
  onboard: '/onboard',
  dashboard: '/dashboard',
  v1Dashboard: '/v1_dashboard',
  v3Dashboard: '/v3_dashboard',
  chargers: '/chargers',
  charger: '/chargers/:chargerId/:connectorId',
  chargersCompare: '/chargers/compare',
  chargersUpdateFirmware: '/chargers/updateFirmware',
  chargersChangeConfig: '/chargers/changeConfig',
  listings: '/listings',
  listing: '/listing/:listingId',
  // listingCreate: '/listing/create',
  transactions: '/transactions',
  v1Transactions: '/v1_transaction',
  transaction: '/transactions/:transactionId',
  v3Transactions: '/v3_transactions',
  v3Transaction: '/v3_transactions/:transactionId',
  tenants: '/tenants',
  tenant: '/tenants/:tenantId',
  tenantsCreate: '/tenant/create',
  users: '/users',
  classicUsersPage: '/classicUsersPage',
  analytics: '/analytics',
  reports: '/reports',
  usersCreate: '/users/create',
  usersAdd: '/users/add',
  user: '/users/:userId',
  action: '/action',
  blankPage: '/blankPage',
  peakShavingPrograms: '/peakShavingPrograms',
  peakShavingProgram: '/peakShavingPrograms/:programId',
  tagging: '/tagging',
  demandManagement: '/demandManagement',
  integrationsMarketplace: '/integrationsMarketplace',
  userWallet: '/users/:userId/wallet',
  tax: '/tax',
}

export const Links = {
  auth0login: compile(Paths.auth0login),
  auth0Callback: compile(Paths.auth0Callback),
  cognitoLogin: compile(Paths.cognitoLogin),
  cognitoCallback: compile(Paths.cognitoCallback),
  cognitoLogout: compile(Paths.cognitoLogout),
  onboard: compile(Paths.onboard),
  dashboard: compile(Paths.dashboard),
  v1Dashboard: compile(Paths.v1Dashboard),
  v3Dashboard: compile(Paths.v3Dashboard),
  chargers: compile(Paths.chargers),
  chargersCompare: compile(Paths.chargersCompare),
  chargersUpdateFirmware: compile(Paths.chargersUpdateFirmware),
  chargersChangeConfig: compile(Paths.chargersChangeConfig),
  charger: compile(Paths.charger),
  // ! comment out until we want to remove the pages completely
  // listings: compile(Paths.listings),
  listing: compile(Paths.listing),
  // listingCreate: compile(Paths.listingCreate),
  transactions: compile(Paths.transactions),
  v1Transactions: compile(Paths.v1Transactions),
  transaction: compile(Paths.transaction),
  v3Transactions: compile(Paths.v3Transactions),
  v3Transaction: compile(Paths.v3Transaction),
  tenants: compile(Paths.tenants),
  tenant: compile(Paths.tenant),
  tenantsCreate: compile(Paths.tenantsCreate),
  users: compile(Paths.users),
  analytics: compile(Paths.analytics),
  reports: compile(Paths.reports),
  usersCreate: compile(Paths.usersCreate),
  usersAdd: compile(Paths.usersAdd),
  user: compile(Paths.user),
  classicUsersPage: compile(Paths.classicUsersPage),
  action: compile(Paths.action),
  blankPage: compile(Paths.blankPage),
  peakShavingPrograms: compile(Paths.peakShavingPrograms),
  peakShavingProgram: compile(Paths.peakShavingProgram),
  tagging: compile(Paths.tagging),
  demandManagement: compile(Paths.demandManagement),
  integrationsMarketplace: compile(Paths.integrationsMarketplace),
  userWallet: compile(Paths.userWallet),
  tax: compile(Paths.tax),
}
